import { useSnapshot } from 'valtio';

import CameraButtons from '@cartwhl/ui/player/CameraButtons';

import { sceneSettingsStore } from 'stores';
import { AnimationPlayerStoreInstance } from 'stores/animationPlayerStoreFactory';

import { DEFAULT_CAMERA_SERIALIZED } from './SceneSetup';

export default function PlayerCameraButtons({
  animationPlayerStore,
  inModal = false,
  variant,
}: {
  animationPlayerStore: AnimationPlayerStoreInstance;
  inModal?: boolean;
  variant?: 'full' | 'simple';
}) {
  const { inputMode } = useSnapshot(animationPlayerStore.state);
  const {
    cameraSettings: { cameraFollow, serializedCamera },
  } = useSnapshot(sceneSettingsStore.state);

  return (
    <div className="hidden sm:block">
      <CameraButtons.Root
        tooltipSide="right"
        inModal={inModal}
        variant={variant}
      >
        <CameraButtons.InputMode
          inputMode={inputMode}
          setCameraInputMode={animationPlayerStore.setCameraInputMode}
        />
        <CameraButtons.Zoom
          zoomIn={animationPlayerStore.zoomIn}
          zoomOut={animationPlayerStore.zoomOut}
        />
        <CameraButtons.Reset
          resetCamera={async () => {
            await animationPlayerStore.resetCamera();
            sceneSettingsStore.set('cameraSettings', 'serializedCamera', '');
          }}
          disableCameraReset={
            !serializedCamera || serializedCamera === DEFAULT_CAMERA_SERIALIZED
          }
        />
        <CameraButtons.CameraFollow
          cameraFollow={cameraFollow}
          setCameraFollow={() => {
            sceneSettingsStore.set(
              'cameraSettings',
              'cameraFollow',
              !cameraFollow,
            );
          }}
        />
      </CameraButtons.Root>
    </div>
  );
}
